
import React from 'react';

interface GoogleTagManagerProps {
  gtmId: string;
}

export const GoogleTagManager: React.FC<GoogleTagManagerProps> = ({ gtmId }) => {
  // Initialize Google Tag Manager on mount
  React.useEffect(() => {
    // Skip if GTM is already initialized
    if (window.dataLayer) {
      return;
    }

    // Initialize dataLayer array
    window.dataLayer = window.dataLayer || [];
    
    // Push gtm.js event
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    // Create and add GTM script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);
    
    console.log('Google Tag Manager initialized with ID:', gtmId);

    // Cleanup on unmount
    return () => {
      // Remove script if needed (usually not necessary)
    };
  }, [gtmId]);

  return null;
};
